import { styled } from '@tools/wr-catalog-base'

export const Section = styled.div`
  padding-bottom: 10px;
  padding-left: 40px;
`

export const Container = styled.div`
  padding: 10px 0;
  font-size: 12pt;
  font-family: 'Calibri', 'CenturyGothic', 'Candara', 'Segoe', 'Segoe UI', 'Optima', 'Arial', sans-serif;
  &.simple-cart {
    ${Section} {
      padding-left: 0;
    }
  }
`
export const PhaseLabel = styled.div`
  color: #68c251;
  font-size: 1.3em;
  &:before {
    content: '';
    border-top: 3px dotted var(--color-green);
    height: 10px;
    display: block;
    margin-left: -20px;
    margin-right: 20px;
  }
`
export const ObjectiveLabel = styled.span`
  font-weight: bold;
  border-bottom: 2px solid currentColor;
  ${(props) =>
    props.isEmpty &&
    `
    font-weight: normal;
    font-style: italic;
    border-bottom: none;
    opacity: 0.5;
  `}
`
